export default __webpack_public_path__ + "static/media/container-gray.5ab0d9de.svg";